import { addDaysToDate, compareConnections, compareCountries, fetchJson, matchesMultiLangString, ResultCache } from "../utils";
export class TrainService {
  constructor() {
    this.njBaseUrl = '/nj-booking';
    this.pvAppsBaseUrl = 'https://pv-apps.web.oebb.at';
    this.maxBookableDate = addDaysToDate(180);
    this.countryCache = new ResultCache((url) => this.loadCountries(url));
    this.connectionListCache = new ResultCache((url) => this.loadConnections(url));
    this.connectionDetailsCache = new ResultCache((url) => this.loadConnectionDetails(url));
    this.offersCache = new ResultCache((url) => this.loadOffers(url));
  }
  static get instance() {
    if (!this._instance) {
      this._instance = new TrainService();
    }
    return this._instance;
  }
  setNjBaseUrl(url) {
    this.njBaseUrl = url;
  }
  setPvAppsBaseUrl(url) {
    this.pvAppsBaseUrl = url;
  }
  setMaxBookableDate(dateString) {
    if (!dateString) {
      return;
    }
    const date = new Date(dateString);
    if (!isNaN(date.valueOf())) {
      this.maxBookableDate = date;
    }
  }
  async loadConfig() {
    const config = await fetchJson(this.njBaseUrl + '/config');
    this.setMaxBookableDate(config.maxBookableDate);
  }
  getMaxBookableDate() {
    return this.maxBookableDate;
  }
  async getGeolocation() {
    var _a;
    try {
      const result = await fetchJson(this.pvAppsBaseUrl + '/geolocation');
      return (_a = result === null || result === void 0 ? void 0 : result.countryCode) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    }
    catch (e) {
      console.log('Error loading geolocation', e);
      return null;
    }
  }
  async findCountriesForDestinationCountry(destinationCountry, carTransport, direction, query = '') {
    let url = direction === 'return'
      ? `/countries/from/country/${destinationCountry}`
      : `/countries/to/country/${destinationCountry}`;
    if (carTransport) {
      url += '?carTransport=true';
    }
    const result = await this.countryCache.get(false, url);
    return query
      ? result === null || result === void 0 ? void 0 : result.filter(country => matchesMultiLangString(country === null || country === void 0 ? void 0 : country.name, query))
      : result;
  }
  async findCountriesForDestinationStation(destinationStation, carTransport, direction, query = '') {
    let url = direction === 'return'
      ? `/countries/from/station/${destinationStation}`
      : `/countries/to/station/${destinationStation}`;
    if (carTransport) {
      url += '?carTransport=true';
    }
    const result = await this.countryCache.get(false, url);
    return query
      ? result === null || result === void 0 ? void 0 : result.filter(country => matchesMultiLangString(country === null || country === void 0 ? void 0 : country.name, query))
      : result;
  }
  async loadCountries(url) {
    const result = await fetchJson(this.njBaseUrl + url);
    return result.sort(compareCountries);
  }
  async findConnectionsForDestinationCountry(originCountry, destinationCountry, travelDate, carTransport, direction) {
    let url = direction === 'return'
      ? `/destinations/country/${destinationCountry}/country/${originCountry}/${travelDate}`
      : `/destinations/country/${originCountry}/country/${destinationCountry}/${travelDate}`;
    if (carTransport) {
      url += '?carTransport=true';
    }
    return this.connectionListCache.get(false, url);
  }
  async findConnectionsForDestinationStation(originCountry, destinationStation, travelDate, carTransport, direction) {
    let url = direction === 'return'
      ? `/destinations/station/${destinationStation}/country/${originCountry}/${travelDate}`
      : `/destinations/country/${originCountry}/station/${destinationStation}/${travelDate}`;
    if (carTransport) {
      url += '?carTransport=true';
    }
    return this.connectionListCache.get(false, url);
  }
  async findConnectionsForType(type, travelDate, carTransport) {
    let url = `/destinations/${type}/${travelDate}`;
    if (carTransport) {
      url += '?carTransport=true';
    }
    return this.connectionListCache.get(false, url);
  }
  async loadConnections(url) {
    const result = await fetchJson(this.njBaseUrl + url);
    return result.sort(compareConnections);
  }
  async getConnectionDetails(connection) {
    return this.connectionDetailsCache.get(false, `/destinations/train/${connection.trainNumber}/${connection.date}`);
  }
  async loadConnectionDetails(url) {
    return fetchJson(this.njBaseUrl + url);
  }
  async getOffers(trainNumber, stationFrom, stationTo, departure, forward) {
    const url = `/destinations/offers/${trainNumber}/${stationFrom}/${stationTo}/${+departure}?forward=${forward}`;
    return this.offersCache.get(false, url);
  }
  async loadOffers(url) {
    return fetchJson(this.njBaseUrl + url);
  }
}
//# sourceMappingURL=train.service.js.map
